import type { ITooltipComp, ITooltipParams } from '@ag-grid-community/core';
import { getNameForDataType } from '@thinkalpha/language-services';
import type { ConcreteDataType, ConcreteUnit } from '@thinkalpha/language-services';
import { FieldTypeNames } from '@thinkalpha/table-client';
import type { FieldType } from '@thinkalpha/table-client';

export class ColumnHeaderTooltip implements ITooltipComp {
    eGui!: HTMLElement;

    init(
        params: ITooltipParams & {
            rawDataType?: string;
            dataType?: ConcreteDataType;
            unit?: ConcreteUnit;
            id?: string;
            isValidationMode?: boolean;
            isDeveloper?: boolean;
        },
    ) {
        const isHeader = params.rowIndex === undefined;

        if (isHeader) {
            const eGui = (this.eGui = document.createElement('div'));

            eGui.innerHTML = `<div class="rounded-xs bg-gray-900 p-2">
                    ${params.isValidationMode ? `<div class="text-red-500">Column not editable</div>` : ''}
                    <div>${params.value}</div> 
                    ${
                        params.rawDataType && params.isDeveloper
                            ? `<div class="mt-1 italic">Raw Data Type: ${FieldTypeNames.get(params.rawDataType as FieldType)} [${params.rawDataType}]</div>`
                            : ''
                    }
                    ${
                        params.dataType
                            ? `<div class="mt-1 italic">Data Type: ${getNameForDataType(params.dataType)}</div>`
                            : ''
                    }
                    ${params.unit ? `<div class="italic">Unit: ${params.unit}</div>` : ''}
                    ${
                        params.id
                            ? `<div class="italic" onClick="navigator.clipboard.writeText('${params.id}')">ID: ${params.id}</div>`
                            : ''
                    }
                <div>`;
        }
    }

    getGui() {
        return this.eGui;
    }
}
